import React from 'react'
import PlotSpecification from './PlotSpecification'
import DefineSequencing from './DefineSequencing'

export default function PlotDefineIndex() {
  return (
    <div className='d-flex flex-column gap-3'>
      <PlotSpecification />
      {/* <DefineSequencing /> */}
    </div>
  )
}
